import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";
import { SharedModule } from "../../../shared.module";
import { ButtonTriggerEvent } from 'src/app/common/components/button/button.component';
import { isEmptyArray } from 'src/app/common/utils/object.extensions';

@Component({
  selector: 'ig-preview-ai-description',
  standalone: true,
  imports: [MatIcon, CommonModule, SharedModule],
  templateUrl: './preview.ai.description.component.html',
  styleUrl: './preview.ai.description.component.scss'
})
export class PreviewAiDescriptionComponent {
  descList: string[];
  selectedIndex: number = -1;

  constructor(
    public dialogRef: MatDialogRef<PreviewAiDescriptionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string[]
  ) {
    if (isEmptyArray(data)) return;
    this.descList = data.filter(x => x);
    this.selectedIndex = 0;
  }

  selectDescription(index: number) {
    this.selectedIndex = index;
  }

  submit(event: ButtonTriggerEvent) {
    this.dialogRef.close(this.descList[this.selectedIndex]);
  }
}
